import { useEffect } from 'react';

import { IContent } from '@/interfaces/lesson';

const Videozz = (props: IContent) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://vjs.zencdn.net/7.5.5/video.js';
    script.async = true;

    script.onload = () => {
      (window as any).vjsloaded = true;
    };

    document.body.appendChild(script);
  }, []);

  return (
    <div className='videozz'>
      <video
        id='my-video'
        poster={`https://nutror-videozz.s3.amazonaws.com/upload/${props.content}.jpg`}
        className='video-js vjs-big-play-centered vjs-fill'
        controls
        preload='auto'
        data-setup='{}'
      >
        <source src={`https://nutror-videozz.s3.amazonaws.com/upload/${props.content}.mp4`} type='video/mp4' />
      </video>
    </div>
  );
};

export default Videozz;
